const insertRow = ({ object, items }) => [
  {
    id: object.id,
    clientId: object.clientId,
    status: object.status,
    name: object.name,
    email: object.email,
    profile: object.profile,
  },
  ...items
];

export default insertRow;
